import React from 'react';
import { GenericErrorPage } from '../../../src/components/errorPages/genericErrorPage';

export const DefaultView = () => (
  <GenericErrorPage title="Please select a project" />
);
